// import useUrlParameter from '../utils/useUrlParameter'
import { swalSlideInOption } from './swal-opt.js'
import { fetchContent } from '../utils/fetch-data.js'
import { surveyBtnEffect } from '../utils/survey-btn-effect.js'
import submitSurvey from '../utils/submitSurvey.js'
import htmlDecode from '../utils/html-decode.ts'
import useUrlParameter from '../utils/useUrlParameter.ts'
import { isTablet } from '../utils/base-init.js'

const chineseVersion = ['zh-tw', 'zh-cn'].includes(window.myvars.loginLangCode)
window.targetPageFn = (url) => {
	window.open(url, '_blank')
	// window.Swal.clickConfirm()
}

function closeBanner() {
	if (window.Swal.isVisible()) {
		window.Swal.close()
		console.debug('close')
	}
	// console.debug('close')
}

function triggerBtnUI() {
	const triggerBtnOutside = document.querySelector('.syzpTrigger__btn')
	if (triggerBtnOutside) {
		triggerBtnOutside.setAttribute('style', 'display:none;')
	}

	$('body').addClass('overflow-auto')
	document.addEventListener('touchmove', closeBanner)
}

const promoText = () => {
	if (chineseVersion) {
		return `
			<div class='OpenSans__font fw800 blue-text fz48 uppercase leading-none mb-10'>${window.myvars['$100 off Annual Subscription to']}</div>
		`
	}

	return `
		<div class='OpenSans__font fw800 blue-text fz48 uppercase leading-none'>${window.myvars['$100 off']}</div>
		<div class='fw800 italic blue-text fz48 leading-none mb-10'>${window.myvars['Annual Subscription to']}</div>
	`
}

async function triggerSyzpModalSlide() {
	const confirmButtonText = window.myvars.submit
	const triggerBtnOutside = document.querySelector('.syzpTrigger__btn')

	// const { eventId, orderId, collapsePromoChannelDesktop, orderNumber } =
	// 	window.orderSummary

	const template = `
			<div class="OutSideClose ps-a hand" onclick="Swal.close()">
      	<svg class="icon-svg icon-svg--size-16" aria-hidden="true" focusable="false">
        	<use xlink:href="#close"></use>
        </svg>
      </div>
    <div class="SlideBox__Wrapper hand" onclick="Swal.clickConfirm()">
      <div class="SlideBoxContainer">
				<header class="SlideBox__header">
					<h3 class="SlideBox__leading fw800 italic fz48 text-black">${
						htmlDecode(window.myvars['Special In-Theater Offer'])
					}</h3>
					<div class="syzpLogo ps-a">
						<img class="imgClass" src="https://media2.shenyun.com/assets/order-summary/zplogo.png" alt="">
					</div>
				</header>
				<div class="SlideBox__body mb-20">
					${htmlDecode(promoText())}
					<div class='italic blue-text fz30 leading-none'>${
						htmlDecode(window.myvars['new video platform'])
					}</div>
				</div>
				<footer class="SlideBox__footer fz30 text-black">
					<div class='SlideBox__footerText'>
						<div class='fw800 italic text-black'>${
							htmlDecode(window.myvars['Visit our booth in the lobby for details'])
						}</div>
						<div>${htmlDecode(window.myvars['See you there'])}</div>
					</div>
					<div class="syzpCard">
						<img class="imgClass" src="https://media2.shenyun.com/assets/order-summary/syzp__card.jpg" alt="">
					</div>
				</footer>
			</div>
    </div>
`

	return window.Swal.fire(
		swalSlideInOption({
			html: template,
			showCloseButton: true,
			allowOutsideClick: true,
			didOpen: triggerBtnUI,
			confirmButtonText,
			container: 'syzpSlide__wrapper',
			backdrop: isTablet ? false : 'none',
			position: 'center-end',
		})
	).then((result) => {
		if (result.isConfirmed) {
			if (window.orderSummary.orderSummarySlideInLink.length)
				window.targetPageFn(window.orderSummary.orderSummarySlideInLink)
		}

		if (triggerBtnOutside) {
			triggerBtnOutside.setAttribute('style', 'display:block')
			const barbaContainer = document.querySelector('.barba-container')
			const barbaContainerStyle = barbaContainer?.style
			const btnWidth = triggerBtnOutside.offsetWidth
			const btnHeight = triggerBtnOutside.offsetHeight
			barbaContainerStyle.setProperty('--syzpBtnRightPosition', `-${(btnWidth>>1)-(btnHeight>>1)}px`)
		}

		// document.body.classList.remove('overflow-auto')
		$('body').removeClass('overflow-auto')
		// if (inPage) clearForm(orderId)
	})
	// }
	//
	// return false
}

// export function triggerByPcParameter () {
// 	const trigerPC = useUrlParameter(window.location.href, 'pc')
// 	if (trigerPC) trigerSyzpModalSlide()
// }

export default triggerSyzpModalSlide
window.triggerSyzpModalSlide = triggerSyzpModalSlide
